import { render, staticRenderFns } from "./_studyRank.vue?vue&type=template&id=0b3694f0&scoped=true"
import script from "./_studyRank.vue?vue&type=script&lang=js"
export * from "./_studyRank.vue?vue&type=script&lang=js"
import style0 from "./_studyRank.vue?vue&type=style&index=0&id=0b3694f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3694f0",
  null
  
)

export default component.exports